export default __webpack_public_path__ + "static/media/gestaodqbs.25570022.svg";